<div class="home-btn d-none d-sm-block">
  <a routerLink=""><i class="mdi mdi-home-variant h2 text-dark"></i></a>
</div>
<div>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-lg-7 bg-light">
        <div
          class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
        >
          <div class="w-100">
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div>
                  <div class="text-center">
                    <div>
                      <img
                        src="assets/images/logo_qrpaybox-bup.png"
                        width="180"
                        alt="logo"
                      />
                    </div>

                    <h4 class="font-size-18 my-2">Đăng ký tài khoản</h4>
                    <!-- <p class="text-muted">
                      Nhận tài khoản miễn phí của bạn ngay bây giờ.</p> -->
                  </div>

                  <div class="p-2">
                    <form
                      class="form-horizontal"
                      [formGroup]="signupForm"
                      (ngSubmit)="onSubmit()"
                    >
                      <ngb-alert
                        type="success"
                        *ngIf="successmsg"
                        [dismissible]="false"
                        >Đăng ký thành công
                      </ngb-alert>
                      <ngb-alert
                        type="danger"
                        *ngIf="error"
                        [dismissible]="false"
                        >Số điện thoại đã tồn tại</ngb-alert
                      >
                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-user-2-line auti-custom-input-icon"></i>
                        <label for="full_name">Họ tên</label>
                        <input
                          type="text"
                          formControlName="full_name"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.full_name.errors }"
                          id="full_name"
                          placeholder="Nhập tên đầy đủ"
                        />
                        <div
                          *ngIf="submitted && f.full_name.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.full_name.errors.required">
                            Tài khoản là bắt buộc
                          </div>
                        </div>
                      </div>
                      <div class="form-group auth-form-group-custom mb-4">
                        <i
                          class="ri-user-location-fill auti-custom-input-icon"
                        ></i>
                        <label for="address">Địa chỉ</label>
                        <input
                          type="address"
                          formControlName="address"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.address.errors }"
                          id="address"
                          placeholder="Nhập địa chỉ"
                        />
                        <div
                          *ngIf="submitted && f.address.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.address.errors.required">
                            Số điện thoại là bắt buộc
                          </div>
                          <div *ngIf="f.address.errors.address">
                            Số điện thoại không đúng
                          </div>
                        </div>
                      </div>
                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-phone-line auti-custom-input-icon"></i>
                        <label for="phone">Số điện thoại</label>
                        <input
                          type="phone"
                          formControlName="phone"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"
                          id="phone"
                          placeholder="Nhập số điện thoại"
                        />
                        <div
                          *ngIf="submitted && f.phone.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.phone.errors.required">
                            Số điện thoại là bắt buộc
                          </div>
                          <div *ngIf="f.phone.errors.pattern">
                            Số điện thoại nhập không đúng
                          </div>
                        </div>
                      </div>
                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-lock-2-line auti-custom-input-icon"></i>
                        <label for="password">Mật khẩu</label>
                        <input
                          type="password"
                          formControlName="password"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                          id="password"
                          placeholder="Nhập mật khẩu"
                        />
                        <div
                          *ngIf="submitted && f.password.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.password.errors.required">
                            Mật khẩu là bắt buộc
                          </div>
                        </div>
                      </div>
                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-lock-2-line auti-custom-input-icon"></i>
                        <label for="confirmPassword">Xác nhận mật khẩu</label>
                        <input
                          type="password"
                          formControlName="confirmPassword"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
                          id="confirmPassword"
                          placeholder="Nhập lại mật khẩu"
                        />
                        <div
                          *ngIf="submitted && f.confirmPassword.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.confirmPassword.errors.required">
                            Nhập lại mật khẩu là bắt buộc
                          </div>
                          <div *ngIf="f.confirmPassword.errors.mustMatch">
                            Mật khẩu không khớp
                          </div>
                        </div>
                      </div>

                      <div class="text-center">
                        <button
                          class="btn btn-viettel btn-outline-danger col-12 waves-effect waves-light"
                          type="submit"
                        >
                          Đăng ký
                        </button>
                      </div>

                      <!-- <div class="mt-4 text-center">
                        <p class="mb-0">By registering you agree to the Nazox <a href="#" class="text-primary">Terms of
                            Use</a></p>
                      </div> -->
                    </form>
                  </div>

                  <div class="mt-2 text-center">
                    <p>
                      Bạn đã có tài khoản ?
                      <a
                        routerLink="/account/login-account"
                        class="font-weight-medium text-primary"
                      >
                        Đăng nhập ngay</a
                      >
                    </p>
                    <!-- <p>© 2020 Nazox. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesdesign</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-block">
        <div
          class="row justify-content-center align-items-center"
          style="height: 100vh;"
        >
          <div class="col-auto">
            <img
              class="img-fluid"
              src="assets/images/logo-login.jpg"
              alt="bg-logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- end page -->
